<template>
<div>
<el-row>
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="title">
<h1>浙江大学校园导视系统设计</h1>
</div>
<div class="picture">
<img src="../assets/project9_14.png.webp"/>
</div>
<div class="abstract">
                    浙江大学紫金港校区西区部分设计已投入使用                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_19.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_8.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_9.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_20.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_10.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="10"><div class="picture equal-height-pair"><img src="../assets/project9_12.png.webp"/></div></el-col>
<el-col :span="10"><div class="picture equal-height-pair"><img src="../assets/project9_13.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_11.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="10"><div class="picture equal-height-pair"><img src="../assets/project9_15.png.webp"/></div></el-col>
<el-col :span="10"><div class="picture equal-height-pair"><img src="../assets/project9_17.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_18.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20"><div class="picture"><img src="../assets/project9_1.png.webp"/></div></el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="5">
<div class="picture">
<img src="../assets/zheda.jpg.webp"/>
</div>
</el-col>
<el-col :span="5">
<div class="picture">
<img src="../assets/project9_5.jpg.webp"/>
</div>
</el-col>
<el-col :span="7">
<div class="picture">
<img src="../assets/project9_2.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="10">
<div class="picture">
                   .
                </div>
</el-col>
<el-col :span="5">
<div class="picture">
<img src="../assets/project9_3.jpg.webp"/>
</div>
</el-col>
<el-col :span="5">
<div class="picture">
<img src="../assets/project9_6.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="10">
<div class="picture">
<img src="../assets/project9_4.jpg.webp"/>
</div>
</el-col>
<el-col :span="7">
<div class="picture">
<img src="../assets/project9_7.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project7Zh"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .equal-height-pair img{
        height: 700px;
        object-fit: contain;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>